<template>
  <section id="skills">
    <h2 class="section-title">Technical Skills</h2>
    <div class="skills-wrapper">
      <div class="skill-group">
        <h3>Backend & Core</h3>
        <div class="tags">
          <span class="tag highlight">Kotlin</span>
          <span class="tag highlight">Java</span>
          <span class="tag">Spring Boot</span>
          <span class="tag highlight">Spring WebFlux</span>
          <span class="tag highlight">Spring MVC</span>
          <span class="tag">JPA/QueryDSL</span>
          <span class="tag">R2DBC</span>
        </div>
      </div>

      <div class="skill-group">
        <h3>Infra & Database</h3>
        <div class="tags">
          <span class="tag">AWS</span>
          <span class="tag highlight">Kafka</span>
          <span class="tag">Redis</span>
          <span class="tag">MySQL</span>
          <span class="tag">PostgreSQL (PostGIS)</span>
          <span class="tag">Docker</span>
        </div>
      </div>

      <div class="skill-group">
        <h3>Frontend & Tools</h3>
        <div class="tags">
          <span class="tag">JavaScript</span>
          <span class="tag">Vue.js</span>
          <span class="tag">React</span>
          <span class="tag">Git / Github</span>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default { name: "SkillsSection" };
</script>
<style scoped>
.section-title {
  font-size: 3rem;
  margin-bottom: 50px;
  text-align: left;
}
.skills-wrapper {
  display: flex;
  flex-direction: column;
  gap: 40px;
}
.skill-group h3 {
  font-size: 1.2rem;
  color: var(--text-tertiary);
  margin-bottom: 20px;
}
.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.tag {
  font-size: 1.1rem;
  padding: 10px 20px;
  border-radius: 12px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  color: var(--text-primary);
  font-weight: 500;
}
</style>
